$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('el-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('el-active');
     jQuery(this).addClass('el-active');
 }
 });




jQuery(document).ready(function(){
    if ($(window).width() >= 915) {
        $('.el-pdt-faq-item1.el-below-media.el-hide-mobile .el-question').trigger('click');
    } else {
        $('.el-pdt-faq-item1.el-below-media.el-hide-desktop .el-question').trigger('click');
    }
});
 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("el-active")) {
    jQuery(this).toggleClass('el-active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('el-active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('el-active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.el-pdt-sold').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});




$(document).on("click", ".el-element-variant", function(e) {
$(this).parents('.el-product').find('.el-element-variant').removeClass('el-active');
$(this).addClass('el-active');
var variant_id = $(this).attr('variant_id');
var quantity = $(this).attr('quantity');
var selling_plan = $(this).attr('selling_plan');
$(this).parents('.el-product').find('.el-variant-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('el-active');
var sub_tab = $('.el-element-sub-option.el-active').attr('sub_tab');
$('.el-checkout-button').attr('quantity',quantity);
$('.el-checkout-button').attr('variant_id',variant_id);
if (sub_tab == '1'){
$('.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.el-checkout-button').removeAttr('selling_plan',selling_plan);
}


var index_count = $(this).index();
 index_count = index_count - 1;
$('.kaching-bundles__bar').eq(index_count).find('label').trigger('click');
});


$(document).on("click", ".el-element-sub-option:not(.el-active)", function(e) {
$(this).parents('.el-product').find('.el-element-sub-option').removeClass('el-active');
$(this).addClass('el-active');
var sub_tab = $(this).attr('sub_tab');
var selling_plan = $('.el-element-variant.el-active').attr('selling_plan');
$(this).parents('.el-product').find('.el-sub-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-sub-trigger[sub_tab="'+sub_tab+'"]').show().addClass('el-active');
if (sub_tab == '1'){
$('.el-button.el-checkout-button').attr('selling_plan',selling_plan);
} else {
$('.el-button.el-checkout-button').removeAttr('selling_plan',selling_plan);
}
$('.kaching-bundles__subscriptions-wrapper .kaching-bundles__bar').trigger('click');
});



$(document).on("click", ".el-element-sub-option.el-active", function(e) {
$('.el-element-sub-option:not(.el-active)').trigger('click');
});











$(document).on("click", ".el-cart-button", function (e) {
    $('.el-cart-drawer').addClass('active');
    $('.el-drawer-cart-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-cart-close, .el-drawer-cart-bg, a[href='#close_cart']", function (e) {
  e.preventDefault();
    $('.el-cart-drawer').removeClass('active');
    $('.el-drawer-cart-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});






 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



 
jQuery(document).ready(function(){
$('.el-pdp-tab .el-element-text ul li:first-child').addClass('el-active');
});



$(document).on("click", ".el-pdp-solution-tab ul li", function (e) {
  e.preventDefault();
  $('.el-pdp-solution-tab ul li').removeClass('el-active');
  $(this).addClass('el-active');
  var index = parseInt($(this).index())+1;
  $('.el-pdp-solution-list').removeClass('el-active');
  $('.el-pdp-solution-list'+index).addClass('el-active');
  $('.el-pdp-solution-left').removeClass('el-active');
  $('.el-pdp-solution-left'+index).addClass('el-active');
});

$(document).on("click", ".el-pdp-formula-tab ul li", function (e) {
  e.preventDefault();
  $('.el-pdp-formula-tab ul li').removeClass('el-active');
  $(this).addClass('el-active');
  var index = parseInt($(this).index())+1;
  $('.el-pdp-formula-list').removeClass('el-active');
  $('.el-pdp-formula-list'+index).addClass('el-active');
});


$(document).on("click", "a[href='#show']", function (e) {
  e.preventDefault();
  $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideDown();
  $('.el-pdp-review2-links:has(a[href="#show"])').hide();
  $('.el-pdp-review2-links:has(a[href="#hide"])').show();
});
$(document).on("click", "a[href='#hide']", function (e) {
  e.preventDefault();
  $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideUp();
  $('.el-pdp-review2-links:has(a[href="#hide"])').hide();
  $('.el-pdp-review2-links:has(a[href="#show"])').show();
});



function initFaqSlider() {
    $('.el-pdt-faq-item1 .el-answer ul.slick-slider').each(function() {
    $(this).slick('unslick');
    });
    $('.el-pdt-faq-item1 .el-answer ul').each(function() {
            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                adaptiveHeight: false,
                responsive: [
                {
                breakpoint: 915,
                settings: {
                slidesToShow: 1,
                 }
                }
                ]
            });
    });
}

$(document).on("click", ".el-pdt-faq-item1 .el-question", function (e) {
                 setTimeout(function () {
  initFaqSlider();
                 }, 100);
                 setTimeout(function () {
  initFaqSlider();
                 }, 500);
});
















function refreshCartDrawer() {
  $.get(window.location.href, function (response) {
    var newContent = $(response).find('.el-cart-drawer-js').html();
    $('.el-cart-drawer-js').html(newContent);
    $('.el-cart-drawer-content').removeClass('el-loading-cart');
    updateCartCount();
    //syncBundleVariant();
  });
  
}

function updateCartCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      var count = 0;
      cart.items.forEach(function (item) {
          count += item.quantity;
      });
      $('.el-cart-count').text(count);
      if (count > 0) {
        $('.el-cart-count').show();
      } else {
        $('.el-cart-count').hide();
      }
      return count;
    })
    .catch(err => console.error('Cart count error:', err));
}




$(document).on('click', '.el-cart-drawer-js .el-quantity-plus, .el-cart-drawer-js .el-quantity-minus', function () {
    $('.el-cart-drawer-content').addClass('el-loading-cart');
  var $btn = $(this);
  var $wrapper = $btn.closest('.el-line-item');
  var $input = $wrapper.find('.el-quantity-input');

  var key = $wrapper.data('key');
  var qty = parseInt($input.val());

  if ($btn.hasClass('el-quantity-plus')) {
    qty++;
  } else {
    qty--;
  }

  // update UI instantly
  $input.val(qty);

  // Shopify AJAX cart update
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    data: {
      id: key,
      quantity: qty
    },
    dataType: 'json',
    success: function (cart) {
        refreshCartDrawer();
    },
    error: function (err) {
      console.error('Cart update failed', err);
    }
  });
});


/*
const PRODUCT_ID = 15936731873612;

const BUNDLES = {
    1: {
        variant: 58243345285452,
        selling_plan: 690998509900
    },
    2: {
        variant: 58243345318220,
        selling_plan: 690998640972
    },
    3: {
        variant: 58243345350988,
        selling_plan: 690998673740
    }
};

let isSyncingBundle = false;

async function syncBundleVariant() {
    if (isSyncingBundle) return;
    isSyncingBundle = true;

    try {
        const cart = await fetch('/cart.js').then(r => r.json());

        const items = cart.items.filter(i => i.product_id === PRODUCT_ID);
        if (!items.length) return;

        // 🔥 TRUE total quantity (NO CLAMP)
        const totalQty = items.reduce((sum, i) => sum + i.quantity, 0);

        // 🔥 tier logic only (no quantity restriction)
        const tier =
            totalQty <= 1 ? 1 :
            totalQty === 2 ? 2 :
            3;

        const bundle = BUNDLES[tier];

        const hasSellingPlan = items.some(i => i.selling_plan_allocation);

        const alreadyCorrect =
            items.length === 1 &&
            Number(items[0].variant_id) === Number(bundle.variant) &&
            Number(items[0].quantity) === totalQty;

        if (alreadyCorrect) return;

        $('.el-cart-drawer-content').addClass('el-loading-cart');

        const updates = {};
        items.forEach(i => updates[i.key] = 0);

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        });

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: bundle.variant,
                    quantity: totalQty,
                    properties: {},
                    ...(hasSellingPlan ? { selling_plan: bundle.selling_plan } : {})
                }]
            })
        });

        refreshCartDrawer();

    } catch (error) {
        console.error('Sync failed:', error);
    } finally {
        isSyncingBundle = false;
        $('.el-cart-drawer-content').removeClass('el-loading-cart');
    }
}

*/



$(document).on("click", '.el-atc-js', function (e) {
  e.preventDefault();
  var $btn = $(this).addClass('el-loading');
  var items = [];
  var variant_id =  $(this).attr('variant_id');
  var selling_plan =  $(this).attr('selling_plan');
  var Item = {
    id: parseInt(variant_id),
    quantity: 1
  };

if (selling_plan) {
    Item.selling_plan = parseInt(selling_plan);
}
  items.push(Item);
  // Single call to /cart/add.js
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: items }),
    dataType: 'json',
    contentType: 'application/json',
    success: function () {
     refreshCartDrawer()
    },
    complete: function () {
      setTimeout(function () {
        $btn.removeClass('el-loading');
      }, 500);
    }
  });
});







$(document).on("click", ".el-pdp-better-list1-item .el-element-texts", function (e) {
  if (jQuery(this).hasClass("el-active")) {
    jQuery(this).toggleClass('el-active');
    jQuery(this).find('.el-element-text').slideToggle();
  } else {
    jQuery('.el-pdp-better-list1-item .el-element-texts').removeClass('el-active');
    jQuery('.el-pdp-better-list1-item .el-element-texts').find('.el-element-text').slideUp();
    jQuery(this).toggleClass('el-active');
    jQuery(this).find('.el-element-text').slideToggle();
  }
});



$(document).on("click", ".el-pdt-label", function (e) {
$('.el-popup').addClass('el-active');
});
$(document).on("click", ".el-pdp-popup-top .el-icon-with-text-flex .el-element-image", function (e) {
$('.el-popup').removeClass('el-active');
});


$(document).on('click', '.el-popup', function (e) {
    if ($(e.target).closest('.el-popup .el-container').length) {
        return;
    }
$('.el-popup').removeClass('el-active');
});
